import { UserType } from "@/components/report/types";
import { KeyboardArrowRight } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { NumberTitle, RiskLabel, ThreeLevelScalesType } from "../commons";
import {
  DailyJudgeTable,
  SLEEP_JUDGE_TITLE_CONFIG,
  SleepJudgeTitle,
} from "./commons";

export interface QualityProps {
  title: SleepJudgeTitle;
  summary: string;
  result: (ThreeLevelScalesType | null)[];
  uuid: string | undefined;
  userType: UserType;
}
export default function Quality({
  title,
  summary,
  result,
  uuid,
  userType,
}: QualityProps) {
  return (
    <>
      <Stack sx={{ mx: 6, gap: 4 }}>
        <NumberTitle number={2}>睡眠の質</NumberTitle>
        <RiskLabel
          type={SLEEP_JUDGE_TITLE_CONFIG[title]}
          title={title}
          summary={summary}
        />
        <DailyJudgeTable data={result} />
        <Stack direction="row" justifyContent="end">
          <Button
            endIcon={<KeyboardArrowRight />}
            size="small"
            sx={{ color: "text.secondary" }}
            component={RouterLink}
            to={`/${userType}/report/${uuid}/quality`}
          >
            詳細を見る
          </Button>
        </Stack>
      </Stack>
    </>
  );
}
